import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SbIcons} from '@ngx-seatback/icons';
import {Permission} from '../../../services/api/permission';

export interface SbButtonItem {
  icon: SbIcons;
  btnClass: string;
  tooltip: string;
  link?: string;
  queryParams?: any[];
  pathParams?: any[];
  action?: string;
  translate?: boolean;
  permissions: Permission[];
}

@Component({
  selector: 'sb-table-buttons',
  templateUrl: './sb-table-buttons.component.html',
  styleUrls: ['./sb-table-buttons.component.scss'],
  standalone: false,
})
export class SbTableButtonsComponent implements OnInit {
  constructor() {}

  @Input() buttons: SbButtonItem[] = [];
  @Output() clickedAction: EventEmitter<SbButtonItem> = new EventEmitter<SbButtonItem>();

  ngOnInit(): void {}
}
